import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface TimeTilCloseStore {
  time?: number;
  setTime: (time?: number) => void;
  expiryHour: number;
  setExpiryHour: (hour: number) => void;
}

export const useTimeTilMarketClose = create<TimeTilCloseStore>()(
  devtools((set) => ({
    time: undefined,
    setTime: (time) => {
      return set({ time });
    },
    expiryHour: 16,
    setExpiryHour: (hour) => {
      return set({ expiryHour: hour });
    },
  }))
);
